/**
 * Whole-utterance alternatives from Web Speech n-best results (docs/decisions/0006).
 *
 * Continuous recognition delivers an utterance as several final segments, each
 * with its own ranked alternatives.  The backend corrector wants alternatives
 * for the whole question, so we take the top transcript and swap in one
 * segment's alternative at a time — most questions are a single segment, where
 * this is simply that segment's alternatives.
 *
 * @param segments  per final segment, its alternatives in rank order (index 0 = top)
 * @param max       cap on alternatives returned (the backend accepts at most 4)
 * @returns         alternative full transcripts, excluding the top one, deduplicated
 */
export function buildAlternatives(segments: string[][], max = 4): string[] {
  const top = segments.map((alts) => (alts[0] ?? "").trim());
  const primary = top.filter(Boolean).join(" ");
  const out: string[] = [];
  for (let i = 0; i < segments.length && out.length < max; i++) {
    for (let j = 1; j < segments[i].length && out.length < max; j++) {
      const alt = segments[i][j]?.trim();
      if (!alt) continue;
      const candidate = top.map((t, k) => (k === i ? alt : t)).filter(Boolean).join(" ");
      if (candidate !== primary && !out.includes(candidate)) out.push(candidate);
    }
  }
  return out;
}
